import React, { memo, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import styles from "./ProviderLayout.module.scss";
import PrivateSidemenu from "./components/PrivateSidemenu";
import ProviderPrivateHeader from "./components/ProviderPrivateHeader";
import { useSelector } from "react-redux";
import { RootState } from "../../stores/store";
import ButtomNav from "./components/ButtomNav";

type Props = {};

const ProviderLayout: React.FC<Props> = memo((props: Props) => {
	const [isColapsed, setIsColapsed] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const firstLogin = useSelector((state: RootState) => state.firstLogin.firstLogin);

	function toggleColapsed() {
		setIsColapsed(!isColapsed);
	}

	function toggleMobileMenu() {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	}

	useEffect(() => {
		setIsDisabled(firstLogin);
	}, [firstLogin]);

	return (
		<div className={styles.container}>
			<ProviderPrivateHeader isColapsed={isColapsed} onMenuClick={toggleColapsed} onMobileMenuClick={toggleMobileMenu} />
			<div className={styles.contentContainer}>
				<PrivateSidemenu mobileMenuOpen={isMobileMenuOpen} isColapsed={isColapsed} isDisabled={isDisabled} onMobileMenuClick={toggleMobileMenu} />
				<div className={`${styles.content} ${isColapsed ? styles.contentWidthCollapsedSideMenu : styles.contentWidthExpandedSideMenu}`}>
					<Outlet />
				</div>
				<ButtomNav />
			</div>
		</div>
	);
});

export default ProviderLayout;
